import React from "react";
import { FaHandshake, FaStar } from "react-icons/fa";
import partner1 from "../assets/business_man.jpg"; // Example image paths
import partner2 from "../assets/business_man.jpg";
import partner3 from "../assets/business_man.jpg";

function TrustedPartners() {
  const partners = [
    {
      name: "Google",
      description: "A brief description of Partner One.",
      logo: partner1,
    },
    {
      name: "Wing",
      description: "A brief description of Partner Two.",
      logo: partner2,
    },
    {
      name: "ABA Bank",
      description: "A brief description of Partner Three.",
      logo: partner3,
    },
  ];

  return (
    <div className="bg-gradient-to-r from-indigo-400 to-purple-600 text-gray-900 p-8 min-h-screen">
      <div className="container mx-auto py-10">
        <h1 className="text-4xl font-bold text-center mb-8 text-white">
          Trusted Partnerships
        </h1>

        {/* Partnership Information */}
        <div className="bg-white bg-opacity-75 rounded-lg p-8 mb-8 flex items-start shadow-lg">
          <FaHandshake className="text-6xl text-yellow-600 mr-6" />
          <div>
            <h2 className="text-3xl font-bold mb-4">Our Trusted Partners</h2>
            <p className="text-lg">
              We collaborate with industry-leading partners to provide the best
              solutions for our clients. Our partnerships are built on trust,
              mutual respect, and shared goals to deliver exceptional results.
            </p>
          </div>
        </div>

        {/* Partner Logos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-white text-gray-800 p-6 rounded-lg shadow-lg transform hover:scale-105 transition duration-300 ease-in-out flex flex-col items-center"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="w-24 h-24 mb-4 rounded-full"
              />
              <h2 className="text-2xl font-bold mb-2">{partner.name}</h2>
              <p className="text-center">{partner.description}</p>
            </div>
          ))}
        </div>

        {/* Partnership Benefits */}
        <div className="bg-white bg-opacity-75 rounded-lg p-8 mt-8 flex items-start shadow-lg">
          <FaStar className="text-6xl text-yellow-600 mr-6" />
          <div>
            <h2 className="text-3xl font-bold mb-4">Why Partner with Us?</h2>
            <p className="text-lg">
              Partnering with us means gaining access to a wealth of expertise
              and resources. Our collaborative approach ensures that we
              understand your unique needs and deliver solutions that drive
              success. Join us and experience the benefits of a trusted
              partnership.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrustedPartners;
